import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BaseComponent } from '../base/base.component';
import { FooterComponent } from '../layout/footer.component';

@Component({
  selector: 'app-login-layout',
  imports: [FooterComponent, RouterModule],
  template: `
    <div
      class="tw-flex bg-section tw-bg-[var(--sed-grey-20-color)] tw-w-full tw-flex-col tw-min-h-screen tw-p-4 lg:tw-p-8 tw-overflow-x-hidden"
    >
      <main
        id="main-content"
        role="main"
        class="tw-grow tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-6"
      >
        <div
          class="tw-hidden lg:tw-flex tw-w-full tw-justify-center tw-items-center"
        >
          <div class="logo-wrapper">
            <img
              src="assets/images/omni-logo-large.webp"
              alt="Omni Logo"
            />
          </div>
        </div>
        <div
          class="lg:tw-pb-16 tw-flex-col tw-w-full lg:tw-w-auto tw-flex-none"
        >
          <div
            class="login-card tw-w-full lg:tw-w-[400px] tw-rounded-2xl tw-p-4 tw-mx-auto"
          >
            <div class="tw-flex tw-items-center tw-p-6">
              <h2 class="tw-text-[30px] tw-font-bold tw-flex-1 tw-text-center">
                Login
              </h2>
            </div>
            <router-outlet></router-outlet>
          </div>
        </div>
        <div
          class="tw-flex lg:tw-hidden tw-flex-col tw-flex-none tw-w-full tw-justify-center tw-items-center tw-pt-1 tw-pb-1"
        >
          <img
            src="assets/images/omni-logo-large.webp"
            alt="Omni Logo"
            class="tw-max-w-[180px] tw-h-auto tw-mx-auto"
          />
        </div>
        <div
          class="bg-section-mobile tw-flex-col tw-flex-none tw-w-full lg:tw-hidden tw-h-[180px] tw-flex tw-justify-center tw-items-center"
        ></div>
      </main>
      <div class="tw-w-full tw-p-4 lg:tw-p-5">
        <app-footer
          [transparent]="true"
          [whatsNew]="true"
          [showFooterLogo]="false"
          [showFooterText]="true"
          [techSupportLiveChat]="true"
        />
      </div>
    </div>
  `,
  styles: `
    .logo-wrapper {
      width: 100%;
      max-width: 500px;
      padding: 0 1rem;
      box-sizing: border-box;
    }

    .logo-wrapper img {
      display: block;
      width: 100%;
      height: auto;
    }

    .login-card {
      background-color: var(--sed-warm-white-color);
      max-width: 400px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    .bg-section {
      background: none;
    }

    @media (max-width: 1023px) {
      .bg-section-mobile {
        background: url('/assets/images/omni-background.webp') center center /
          contain no-repeat;
      }

      :host ::ng-deep .footer {
        padding-top: 0 !important;
      }

      :host ::ng-deep .footer-links-host {
        justify-content: center !important;
      }

      :host ::ng-deep .footer-links-host ul {
        flex-direction: column !important;
        align-items: center !important;
        text-align: center !important;
      }

      :host ::ng-deep .copyright {
        justify-content: center !important;
      }
    }

    @media (min-width: 1024px) {
      .bg-section {
        background: url('/assets/images/omni-background.webp') center 40% /
          900px 450px no-repeat;
      }
    }

    @media (min-width: 1280px) {
      .bg-section {
        background: url('/assets/images/omni-background.webp') center 40% /
          1100px 550px no-repeat;
      }
    }

    @media (min-width: 1536px) {
      .bg-section {
        background: url('/assets/images/omni-background.webp') center 40% /
          1400px 700px no-repeat;
      }
    }

    .login-card,
    .login-card-inner,
    .login-form-wrapper {
      overflow-x: visible;
      min-width: 0;
      box-sizing: border-box;
    }

    .login-form-wrapper > * {
      min-width: 0;
      max-width: 100%;
    }
  `,
})
export class LoginLayoutComponent extends BaseComponent {}
